import script from "./DeepStrategy.vue?vue&type=script&setup=true&lang=js"
export * from "./DeepStrategy.vue?vue&type=script&setup=true&lang=js"

import "./DeepStrategy.vue?vue&type=style&index=0&id=59c2efb7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59c2efb7"]])

export default __exports__